var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_14467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4989 41.9018C35.0764 41.9018 41.2191 35.7591 41.2191 28.1817C41.2191 20.6042 35.0764 14.4615 27.4989 14.4615C19.9215 14.4615 13.7788 20.6042 13.7788 28.1817C13.7788 35.7591 19.9215 41.9018 27.4989 41.9018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.617 35.0448L3.7369 14.4679C1.32802 18.6388 0.0597365 23.3705 0.0595703 28.1871C0.0594042 33.0037 1.32736 37.7354 3.73595 41.9065C6.14454 46.0776 9.60887 49.5411 13.7806 51.9487C17.9523 54.3562 22.6843 55.623 27.5009 55.6217L39.381 35.0448V35.0412C38.1777 37.1279 36.4462 38.8609 34.3605 40.0659C32.2749 41.2709 29.9088 41.9056 27.5 41.9059C25.0913 41.9063 22.7249 41.2724 20.6389 40.0679C18.553 38.8635 16.8209 37.131 15.617 35.0448Z",
    fill: "url(#paint0_linear_116_14467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3801 35.044L27.5001 55.6209C32.3167 55.6216 37.0485 54.3542 41.2199 51.9459C45.3912 49.5378 48.8551 46.0739 51.2631 41.9025C53.6711 37.7309 54.9384 32.999 54.9376 28.1824C54.9367 23.3658 53.6677 18.6344 51.2582 14.4637H27.4981L27.4951 14.4656C29.9039 14.4644 32.2704 15.0975 34.3568 16.3011C36.4433 17.5048 38.1759 19.2366 39.3806 21.3225C40.5853 23.4083 41.2194 25.7746 41.2194 28.1833C41.2194 30.592 40.5848 32.9582 39.3801 35.044Z",
    fill: "url(#paint1_linear_116_14467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4989 39.0466C33.4977 39.0466 38.3608 34.1836 38.3608 28.1848C38.3608 22.186 33.4977 17.323 27.4989 17.323C21.5001 17.323 16.6372 22.186 16.6372 28.1848C16.6372 34.1836 21.5001 39.0466 27.4989 39.0466Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4992 14.4645H51.2593C48.8515 10.2929 45.388 6.8287 41.2168 4.42026C37.0456 2.01183 32.3138 0.744043 27.4972 0.744385C22.6806 0.744727 17.949 2.01318 13.7782 4.42221C9.60724 6.83123 6.14418 10.296 3.73706 14.4678L15.6171 35.0447L15.6201 35.0464C14.4148 32.9609 13.7797 30.595 13.7789 28.1862C13.7782 25.7775 14.4117 23.411 15.6158 21.3249C16.8198 19.2387 18.552 17.5063 20.638 16.3021C22.724 15.0977 25.0904 14.464 27.4992 14.4645Z",
    fill: "url(#paint2_linear_116_14467)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_14467",
    x1: 30.4692,
    y1: 53.9079,
    x2: 6.70816,
    y2: 12.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_116_14467",
    x1: 23.4964,
    y1: 55.6937,
    x2: 47.2575,
    y2: 14.5382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_116_14467",
    x1: 3.73707,
    y1: 17.8953,
    x2: 51.2593,
    y2: 17.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_14467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.8806,
    height: 54.8806,
    fill: "white",
    transform: "translate(0.0595703 0.744385)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.9b7f781d97f170dab0dac7c29af9c5a5.svg";
export { ForwardRef as ReactComponent };